module.exports = __webpack_public_path__ + "img/47.18b04bd4.png";